<template>
  <div class="sign section--bg" data-bg="img/bg.jpg">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="sign__content">
            <!-- authorization form -->
            <div class="sign__form">
              <a class="sign__logo">
                <img src="/logo_white.svg" alt="">
              </a>

              <div class="sign__group">
                <input type="text" v-model="phone" class="sign__input" placeholder="موبایل">
              </div>

              <div class="sign__group">
                <input type="password" v-model="code" class="sign__input" placeholder="رمز عبور">
              </div>

              <div class="sign__group sign__group--checkbox" @click="send_code()">
                <label style="color: white">فراموشی رمز عبور</label>
              </div>
              <div class="sign__group sign__group--checkbox">
                <input id="remember" name="remember" type="checkbox" checked="checked">
                <label for="remember">بخاطر بسپار</label>
              </div>

              <button class="sign__btn" @click="login()" type="button">ورود</button>


            </div>
            <!-- end authorization form -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: 'Account',
  data() {
    return {
      phone: '',
      code: '',
      level: 1,
    }
  },
  components: {},
  mounted() {

  },
  methods: {
    send_code() {
      var self = this;
      if (this.phone.length != 11 || !this.phone.startsWith('0')) {
        self.$toast.error("شماره موبایل را به صورت صحیح وارد کنید", {position: 'bottom-right', duration: 3000})
        return
      }

      const formData = new FormData();
      var url = "send_code";
      formData.append('mobile', this.phone);

      // formData.append('id', "1532");
      axios.post(url, formData, {}).then(function (response) {

        self.$toast.success("رمز عبور برای شما ارسال شد", {position: 'bottom-right', duration: 3000})


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    login() {
      var self = this
      const formData = new FormData();
      formData.append("phone", this.phone);
      formData.append("code", this.code);
      var url = "/admin_login";

      // formData.append('id', "1532");
      axios.post(url, formData, {}).then(function (response) {
        if (response.data.error == 0) {
          localStorage.setItem("login_info", response.data.data);
          self.$router.push({path: '/home'});
        } else {
          self.$toast.error(response.data.msg);

        }

      })
          .catch(function (error) {

            console.log(error);
          });
    }
  }
}
</script>
<style>
.login {
  background: white;
  border-radius: 7px;
  padding: 20px;
}

.login input {
  font-size: 1.5rem;
  width: 70%;
  line-height: 2;
}

.login button {
  width: 30%;
}
</style>
